import { getManifest, loadMarkdown } from "@/utils/markdownLoader";

type ReleaseManifestFile = {
  slug: string;
  date: string;
};

type ReleaseInfo = {
  slug: string;
  version: string;
};

function manifestDateValue(dateStr: string) {
  const [month, day, year] = String(dateStr).split("/").map(Number);
  return new Date(year, month - 1, day).getTime();
}

export async function getLatestReleaseInfo(): Promise<ReleaseInfo | null> {
  try {
    const manifest = await getManifest("release-notes");
    const releases = (
      (manifest.files ?? []) as unknown as ReleaseManifestFile[]
    ).filter((file) => file.slug !== "all-release-notes");

    if (!releases.length) return null;

    const latest = releases.reduce<ReleaseManifestFile | null>(
      (best, current) => {
        if (!best) return current;
        return manifestDateValue(current.date) > manifestDateValue(best.date)
          ? current
          : best;
      },
      null,
    );

    if (!latest?.slug) return null;

    const data = await loadMarkdown(`release-notes/${latest.slug}`);
    const version = String(data?.frontmatter?.releaseVersion ?? latest.slug);

    return {
      slug: latest.slug,
      version,
    };
  } catch (error) {
    console.error("Failed to load latest release info:", error);
    return null;
  }
}
